import { useState } from 'react';

/** Anmeldung ohne Passwort per E-Mail-Link (Supabase Magic Link) – für Verwaltung und Dozenten-App */
export function Anmeldung({ titel, anmelden, gesendet }: { titel: string; anmelden: (email: string) => Promise<void>; gesendet: boolean }) {
  const [email, setEmail] = useState('');
  const [fehler, setFehler] = useState('');
  return (
    <div className="startbild">
      <form className="anmeldung karte" onSubmit={async e => { e.preventDefault(); setFehler(''); try { await anmelden(email); } catch (x) { setFehler(String((x as Error).message)); } }}>
        <span className="marke-zeichen gross" aria-hidden="true">M</span>
        <h1>{titel}</h1>
        {gesendet ? <p>Wir haben Ihnen einen Anmeldelink an <strong>{email}</strong> geschickt. Bitte öffnen Sie ihn auf diesem Gerät.</p> : <>
          <p className="leise">Anmeldung ohne Passwort: Sie erhalten einen Link per E-Mail.</p>
          <label className="feld"><span className="feld-label">E-Mail-Adresse</span><input id="anmeldung-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" /></label>
          {fehler && <p className="hinweisbox fehler">{fehler}</p>}
          <button className="knopf knopf-primaer" type="submit">Anmeldelink senden</button>
        </>}
      </form>
    </div>
  );
}
